import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { JURIDISK_GJENNOMGAATT, SELSKAP, VILKAAR_VERSJON } from '../lib/selskap';
import { orgnummerForDokument } from '../lib/selskap';

/**
 * Rammen rundt et juridisk dokument.
 *
 * Samme skall for personvern, bruksvilkår og salgsbetingelser, så de tre ser ut
 * som tre kapitler i det samme og ikke tre løse ark. Datoen står øverst: det
 * første man vil vite om et vilkårsdokument, er når det sist ble endret.
 */
export function Juridisk({
  tittel,
  ingress,
  children,
}: {
  tittel: string;
  ingress: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="legal-page">
      <Link to="/" className="small">
        ← Tilbake til forsiden
      </Link>
      <h1>{tittel}</h1>
      <p className="muted">Sist endret {VILKAAR_VERSJON}.</p>

      {JURIDISK_GJENNOMGAATT ? null : (
        // Står synlig til en jurist har sett på teksten. Et dokument som ser
        // ferdig ut, blir lest som om det er det – og da er det verre å ta feil
        // enn å si fra.
        <p className="utkastmerke">
          <strong>Utkast.</strong> Teksten er ikke juridisk gjennomgått ennå. Sett{' '}
          <code>JURIDISK_GJENNOMGAATT</code> i <code>apps/web/src/lib/selskap.ts</code> når den er
          det.
        </p>
      )}

      {ingress}
      {children}

      <h2>Hvem du har avtale med</h2>
      <address className="selskapsboks">
        <strong>{SELSKAP.navn}</strong>
        <br />
        Organisasjonsnummer {orgnummerForDokument()}
        <br />
        {SELSKAP.adresse}
        <br />
        {SELSKAP.postnummerOgSted}, {SELSKAP.land}
        <br />
        <a href={`mailto:${SELSKAP.epost}`}>{SELSKAP.epost}</a>
      </address>
      <p className="small muted">
        {SELSKAP.navn} driver tjenesten {SELSKAP.tjeneste} på {SELSKAP.nettsted}.
        {SELSKAP.iForetaksregisteret ? ' Selskapet er registrert i Foretaksregisteret.' : ''}
      </p>
    </div>
  );
}
